var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from "react";
import { IdenticonsCustomProperty, useColorMap } from "../common";
export var IdenticonCustomization = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(" + IdenticonsCustomProperty.light + ", " + colorMap.light + ")",
        base: "var(" + IdenticonsCustomProperty.base + ", " + colorMap.base + ")",
        dark: "var(" + IdenticonsCustomProperty.dark + ", " + colorMap.dark + ")",
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M9.323 10H22v32H9.323a3.29 3.29 0 01-2.328-.966 3.302 3.302 0 01-.964-2.333V13.299c0-.875.347-1.714.964-2.333A3.29 3.29 0 019.323 10z", fill: fills.base }),
        React.createElement("path", { d: "M34.701 42H22V26h16v12.701A3.3 3.3 0 0134.701 42z", fill: fills.light }),
        React.createElement("path", { d: "M26 6h12.82a3.349 3.349 0 013.348 3.348V22H26V6z", fill: fills.dark })));
};
